















































import Vue from 'vue'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { GridOptions } from '@/types'
import { LOAD_EMPLOYEE_QCQ_QUALIFICATION, EDIT_EMPLOYEE_QCQ_QUALIFICATION } from '@/store/action-types'
import QcqQualificationDialog from './QcqQualificationDialog.vue'
import { EmployeeQcqQualification } from '@/model/employee/EmployeeQcqQualification'
import { KeyActionEnum, MasterDataActionsEnum } from '@/types/enums'
import { EmployeeQcqQualificationPayload, EmployeeQcqQualificationItemPayload } from '@/types/payload'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { hexToRgba } from '@/services/hex-to-rgba'
import { keyActionService } from '@/services/key-action-service'
import { KeyAction } from '@/model/KeyAction'

class Create extends KeyAction {}
class Edit extends KeyAction {}
class Delete extends KeyAction {}

interface ComponentData {
  gridData: Array<any>
  gridOptions: GridOptions
  showQcqQualificationDialog: boolean
  selectedQualificationId: number | undefined
  selectedQualificationData: EmployeeQcqQualification | undefined
  action: MasterDataActionsEnum | undefined
  showDeleteDialog: boolean
  showErrorSnackbar: boolean
  showSuccessSnackbar: boolean
  loading: boolean
  errorMessage: string
  successMessage: string
  overlayNoRowsTemplate: string

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'QcqQualification',

  components: {
    AgGridVue,
    QcqQualificationDialog,
    DeleteDialog
  },

  props: {
    employeeId: Number
  },

  data (): ComponentData {
    return {
      gridData: [],
      gridOptions: {
        columnDefs: [
          { headerName: this.$t('employeeFormComponent.qcq.education'), field: 'education' },
          { headerName: this.$t('employeeFormComponent.qcq.job'), field: 'job' },
          { headerName: this.$t('employeeFormComponent.qcq.specialization'), field: 'specialization' },
          { headerName: this.$t('employeeFormComponent.qcq.details'), field: 'details' },
        ]
      },
      showQcqQualificationDialog: false,
      selectedQualificationId: undefined,
      selectedQualificationData: undefined,
      action: undefined,
      showDeleteDialog: false,
      showErrorSnackbar: false,
      showSuccessSnackbar: false,
      loading: false,
      errorMessage: '',
      successMessage: '',
      overlayNoRowsTemplate: "<span>"+this.$t('errors.noRowsToShow')+"</span>",

      keyActions: []
    }
  },

  computed: {
    isEnableButtons (): boolean {
      return !!this.selectedQualificationId
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    }
  },

  watch: {
    employeeId (newVal: Number): void {
      if (newVal) {
        this.fetchQualificationList()
      }
    },
  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: Create | Edit | Delete | null): boolean {
      if(action instanceof Create) {
        return true
      } else if(action instanceof Edit) {
        return this.isEnableButtons
      } else if(action instanceof Delete) {
        return this.isEnableButtons
      } else {
        return false
      }
    },

    onAddQualificationClick (): void {
      const emptyModelData: EmployeeQcqQualificationItemPayload = {
        id: null,
        employeeId: this.employeeId,
        education: '',
        educationId: null,
        educationLanguage: 0,
        job: '',
        jobId: null,
        jobLanguage: 0,
        specialization: '',
        specializationId: null,
        specializationLanguage: 0,
        details: '',
        detailsId: null,
        detailsLanguage: 0
      }
      this.selectedQualificationData = EmployeeQcqQualification.createFromData(emptyModelData)
      this.action = MasterDataActionsEnum.Create
      this.showQcqQualificationDialog = true
    },

    create (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onAddQualificationClick()
    },

    onEditQualificationClick (): void {
      this.selectedQualificationData = this.gridData.find((item: any) => item.id === this.selectedQualificationId)
      this.action = MasterDataActionsEnum.Update
      this.showQcqQualificationDialog = true

    },

    update (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onEditQualificationClick()
    },

    onDeleteQualificationClick (): void {
      this.selectedQualificationData = this.gridData.find((item: any) => item.id === this.selectedQualificationId)
      this.action = MasterDataActionsEnum.Delete
      this.showDeleteDialog = true
    },

    delete (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onDeleteQualificationClick()
    },

    deleteQualification (): void {
      if (this.selectedQualificationData) {
        const payload: EmployeeQcqQualificationPayload = {
          educationId: this.selectedQualificationData.educationId,
          jobId: this.selectedQualificationData.jobId,
          specializationId: this.selectedQualificationData.specializationId,
          detailsId: this.selectedQualificationData.detailsId,
          action: '',
          id: this.selectedQualificationData.id,
          employeeId: this.employeeId
        }
        this.onQcqQualificationDialogSave(payload)
      }
      this.showDeleteDialog = false
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
      this.action = undefined
    },

    onRowClicked (params: any): void {
      this.selectedQualificationId = params.data.id
    },

    onRowDoubleClicked (params: any): void {
      this.selectedQualificationId = params.data.id
      this.selectedQualificationData = this.gridData.find((item: any) => item.id === this.selectedQualificationId)
      this.action = MasterDataActionsEnum.Update
      this.showQcqQualificationDialog = true
    },

    async onQcqQualificationDialogSave (payload: EmployeeQcqQualificationPayload): Promise<void> {
      if (this.action) {
        payload.action = this.action
      }
      try {
        this.loading = true
        await this.$store.dispatch(EDIT_EMPLOYEE_QCQ_QUALIFICATION, payload)
        this.loading = false
        this.showQcqQualificationDialog = false
        this.selectedQualificationId = undefined
        this.selectedQualificationData = undefined
        if (this.action === MasterDataActionsEnum.Delete) {
          this.successMessage = this.$t('success.dataHaveBeenDeleted').toString()
        } else {
          this.successMessage = this.$t('success.dataHaveBeenSaved').toString()
        }
        this.action = undefined
        this.showSuccessSnackbar = true
        this.fetchQualificationList()
      } catch (e) {
        this.loading = false
        if (this.action === MasterDataActionsEnum.Delete) {
          this.errorMessage = this.$t('success.dataCouldNotBeDeleted').toString()
        } else {
          this.errorMessage = this.$t('success.dataCouldNotBeSaved').toString()
        }
        this.showErrorSnackbar = true
      }
    },

    onQcqQualificationDialogClose (): void {
      this.showQcqQualificationDialog = false
    },

    async fetchQualificationList (): Promise<void> {
      const payload: number = this.employeeId

      const data = await this.$store.dispatch(LOAD_EMPLOYEE_QCQ_QUALIFICATION, payload)

      this.gridData = data
    }
  },

  beforeMount () {
    this.keyActions = [
      new Create(KeyActionEnum.create, this.create, this.resolver,  null),
      new Edit(KeyActionEnum.edit, this.update, this.resolver, null),
      new Delete(KeyActionEnum.delete, this.delete, this.resolver, null),
    ]
  },

  mounted (): void {
    window.addEventListener('keydown', this.onKeydown)
    this.fetchQualificationList()
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
